import { NgForm } from '@angular/forms';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { Provider, EMAILPROVIDERS, SendGrid, Smtp } from "../../model/providers.modals"
import { UtilityService } from 'src/app/services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { Type } from '@angular/compiler';

@Component({
  selector: 'app-email-providers',
  templateUrl: './email-providers.component.html',
  styleUrls: ['./email-providers.component.css']
})
export class EmailProvidersComponent implements OnInit {

  constructor(private utilityService: UtilityService, private toastrService: ToastrService) {
    this.provider = new Provider();
  }
  useMyCustomProvider: boolean = false;
  selectedProviderTemplate: TemplateRef<any> = null;
  provider: Provider;
  defaultProvider: any; //1:sendgrid,2:smtp
  isDoubleClick: boolean = true;
  lastClickedProvider: any;
  clientID: any;
  countOfProviders: number;
  isTestingMail:boolean=false;
  isLoading:boolean;
  ngOnInit() {
    this.clientID = localStorage.getItem("org_id");
    this.initialize();
  }
  initialize() {
    this.isLoading=true
    this.utilityService.getClientProvider(this.clientID).subscribe((res: any) => {
      if (res != null) {
        this.useMyCustomProvider = res.isCustomProvider;
        if (res.provider != null) {
          this.provider.setting = res.provider;
          this.defaultProvider = res.provider.providerId;
        }
        this.countOfProviders = res.count;
        if (!res.isCustomProvider) {  //if the custom provider is off
          this.defaultProvider = -1;
        }
      }
      this.isLoading=false
    },
    (err)=>{this.isLoading=false}
    )
  }
  onProviderToggle(event: any) {
    this.utilityService.toggleCustomProvider({ clientId: this.clientID, useMyCustomProvider: event }).subscribe((res: any) => {
      if (!res.error)
        this.toastrService.success(`Custom provider option set ${event ? ' on ' : ' off '} successfully`);
      if (!event) {
        this.defaultProvider = -1;
      } else {
        this.initialize();
      }
    }, error => {
      this.toastrService.error(error.error);

    })
    this.selectedProviderTemplate = null;

  }
  onSendGridClick(template: TemplateRef<any>) {
    this.isDoubleClick = true;
    setTimeout(() => { this.isDoubleClick = false }, 250);
    if (this.isDoubleClick && this.lastClickedProvider == EMAILPROVIDERS.SENDGGRID)
      this.setDefaultProviderOnDoubleClick(EMAILPROVIDERS.SENDGGRID);
    else {
      this.provider.setting = new SendGrid();
      this.getDetail(EMAILPROVIDERS.SENDGGRID);
      this.selectedProviderTemplate = template;
      this.lastClickedProvider = EMAILPROVIDERS.SENDGGRID;
    }
  }
  onSmtpClick(template: TemplateRef<any>) {
    this.isDoubleClick = true;
    setTimeout(() => { this.isDoubleClick = false }, 250);
    if (this.isDoubleClick && this.lastClickedProvider == EMAILPROVIDERS.SMTP)
      this.setDefaultProviderOnDoubleClick(EMAILPROVIDERS.SMTP);
    else {
      this.provider.setting = new Smtp();
      this.selectedProviderTemplate = template;
      this.lastClickedProvider = EMAILPROVIDERS.SMTP;
      this.getDetail(EMAILPROVIDERS.SMTP);
    }
  }

  onSave() {
    this.provider.clientId = this.clientID;
    this.provider.providerId = EMAILPROVIDERS.SMTP;
    if (this.provider.setting instanceof SendGrid) {
      this.provider.providerId = EMAILPROVIDERS.SENDGGRID;
    }
    if (this.countOfProviders == 0) {
      this.provider.isDefault = true;
      this.defaultProvider = this.provider.providerId;
    }
    else
      this.provider.isDefault = false;
    this.utilityService.saveProviders(this.provider).subscribe((res: any) => {
      this.toastrService.success(res.message);
      this.countOfProviders++;
    }, error => {
      this.toastrService.error(error.message)
    })
  }
  clearModals() {
    this.provider.setting = null;
  }
  getDetail(provider: EMAILPROVIDERS) {
    this.utilityService.getProviderDetails(this.clientID, provider).subscribe((res: Provider) => {
      if (res != null) {
        this.provider.isDefault = res.isDefault;
        this.provider.providerId=res.providerId;
        if (res.providerId == EMAILPROVIDERS.SENDGGRID) {
          this.provider.map(res.setting as SendGrid) ;
        } else {
          this.provider.map(res.setting as Smtp) ;
        }
      }
    })
  }
  //copy object properties

  setDefaultProviderOnDoubleClick(provider: EMAILPROVIDERS) {
    if (this.defaultProvider != provider)
      this.utilityService.setDefaultProvider({ clientId: this.clientID, providerId: provider, isDefault: true }).subscribe((res: any) => {
        if (!res.error) {
          this.defaultProvider = provider;
          switch (provider) {
            case EMAILPROVIDERS.SENDGGRID:
              this.toastrService.info("SendGrid is set to your default email provider");
              break;
            case EMAILPROVIDERS.SMTP:
              this.toastrService.info("SMTP setting are set for default mailing");
              break;
          }
        }
      }, error => {

      })
  }
  sendTestMail(form:NgForm,type:number){
    if(form.invalid) return
    this.isTestingMail=true
    const providerConfig=JSON.parse(JSON.stringify(form.value))
    providerConfig.type=type
    this.utilityService.sendTestMail(providerConfig).subscribe(
      (response:any)=>{
        if(response.error) this.toastrService.error(response.message)
        else this.toastrService.success(response.message)
        this.isTestingMail=false
      },
      (error)=>{
        this.toastrService.error(error)
        this.isTestingMail=false
      }
    )
  }
  cancel(){}
}
